// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".label[data-v-e7474454] {\n  font-size: 12px;\n  color: #999;\n}", ""]);
// Exports
module.exports = exports;
